module.exports = __webpack_public_path__ + "img/logo.c97f49f8.svg";